import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import PhotoOrInitials from 'components/photo_or_initials';

export default function TagTooltip({ tag }) {
  const parts = [
    tag.name,
    tag.businessLabel,
    tag.email,
    tag.phoneNumber,
  ].filter(part => part);

  if (parts.length === 0) {
    return null;
  }

  return (
    <div
      aria-label="tag-tooltip"
      className={classNames('deal-tagged-body-tag-tooltip d-flex align-items-center', {
        // Storybook and tagify rendering don't place all that nicely together
        force: tag._forceTooltip,
      })}
    >
      <PhotoOrInitials user={tag} />
      <div className="ml-3">
        {parts.map((part, i) => (
          <div className="one-line" key={i}>{part}</div>
        ))}
      </div>
    </div>
  );
}

TagTooltip.propTypes = {
  tag: PropTypes.shape({
    businessLabel: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
};
